export enum TestExecutionStatus {
  Started,
  InProgress,
  Paused,
  Finished,
  Aborted
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-execution-status/test-execution-status.ts